export const Mixins = {
    data: () => ({
        time:[
            {
                text: '1 minuto',
                value: '1'
            },
            {
                text: '5 minutos',
                value: '5'
            },
            {
                text: '10 minutos',
                value: '10'
            },
            {
                text: '15 minutos',
                value: '15'
            },
            {
                text: '30 minutos',
                value: '30'
            },
            {
                text: '1 hora',
                value: '60'
            },
        ],
        tipos:[
          {
            text:'Fila',
            value:['queue']
          },
          {
            text:'Direta',
            value:['direct']
          },
          {
            text:'Fila e Direta',
            value:['direct','queue']
          },
        ],
    }),

    computed: {
        todasTagsSelecionadas() {
            return this.form.tags.length === this.tags.length
          },
          algumasTagsSelecionadas() {
            return this.form.tags.length > 0 && !this.todasTagsSelecionadas
          },
          icon() {
            if (this.todasTagsSelecionadas) return 'mdi-close-box'
            if (this.algumasTagsSelecionadas) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
          },
    },

    methods: {
        converterTempo(numero){
            var p = numero.split(':'),
                s = 0, m = 1;
            while (p.length > 0) {
                s += m * parseInt(p.pop(), 10);
                m *= 60;
            }
            return s;
          },
      
          toggle() {
          this.$nextTick(() => {
            if (this.todasTagsSelecionadas) {
              this.form.tags.splice(0)
            } else {
              this.form.tags.splice(0)
              this.form.tags = this.tags.map(tags => tags.value)
            }
          })},
    },
}